<template>
  <div>
    <div class="top-bg">
      <!--头部开始 -->
      <top-part :rightPart="true">
        <div slot="difinePort" class="top-right-box">
          <router-link tag="p" class="integral-box" to="/stepRank">
            <img class="right-img" src="../../assets/images/step_right.png" />
            全部排名
          </router-link>
        </div>
      </top-part>
      <!-- 头部结束 -->

      <div class="content-box">
        <img style="width: 100%;height: 205px;" src="../../assets/images/detailBg.png" />
        <!-- 时间选择组件开始 -->
        <step-time @changeDate="changeDate"></step-time>
        <!-- 时间选择组件结束 -->

        <div class="info-step-box">
          <!-- 当前步数信息开始 -->
          <step-info :getStepInfo="stepInfos"></step-info>
          <!-- 当前步数信息结束 -->
          <!-- 条形图开始 -->
          <div class="seven-box">
            <seven-count :eachrtsDate="eachrtsDate"></seven-count>
          </div>
          <!-- 条形图结束 -->
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import moment from "moment";
import topPart from "../../components/topPart";
import stepTime from "./components/StepTime";
import stepInfo from "./components/StepInfo";
import SevenCount from "./components/SevenCount";
export default {
  components: {
    topPart,
    stepTime,
    stepInfo,
    SevenCount
  },
  data() {
    return {
      changeTime: moment(this.centralControl.utils.obtainEast8Date()).format(
        "YYYY-MM-DD"
      ),
      stepInfos: {},
      eachrtsDate: {}
    };
  },
  watch: {},
  created() {
    // 修改背景颜色
    let htmlObj = document.getElementsByTagName("html")[0];
    htmlObj.style.background = "#F4F5F9";
  },
  mounted() {
    this.init();
  },
  methods: {
    // 获取步数
    getStep(date) {
      let time = date;
      this.centralControl.axios.centralControl(
        "stepAll",
        res => {
          if (res.code == 200) {
            res.data.stepCount =
              JSON.stringify(res.data) === "{}" ? "0" : res.data.stepCount;
            this.stepInfos = res.data;
            console.log(this.stepInfos);
          } else {
            this.$message.error(res.message);
          }
        },
        { stepDay: time }
      );
    },
    // 获取近七天统计步数
    getsevenDate() {
      this.centralControl.axios.centralControl(
        "sevenStep",
        res => {
          if (res.code == 200) {
            this.eachrtsDate = res.data;
            console.log(res.data);
          } else {
            this.$message.error(res.message);
          }
        },
        {}
      );
    },
    init() {
      this.getStep(this.changeTime);
      this.getsevenDate();
    },
    // 接收子组件传递的时间
    changeDate(data) {
      this.getStep(data);
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/common.styl';
html {
  background: #F4F5F9 !important;
}
.top-bg {
  // position: relative;
  // background:url(../../../assets/images/detailBg.979026a0.png) no-repeat 5px 5px;
}

.seven-box {
  position: absolute;
  width: 100%;
  margin-top: 35px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 5px 0px rgba(212, 218, 235, 0.5);
  border-radius: 8px;
  padding: 20px 10px 0;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.info-step-box {
  background: rgba(255, 255, 255, 1);
  position: absolute;
  width: 94%;
  margin: auto;
  left: 0;
  right: 0;
  top: 23%;
  // bottom: -10px;
  box-shadow: 0px 2px 6px 0px rgba(212, 218, 235, 0.5);
  border-radius: 8px;
}

.content-box {
  myContent();

  .centent-text1 {
    text-align: center;
    font-size: 14px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;

    b {
      font-size: 26px;
      font-family: DIN-Bold, DIN;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 31px;
      vertical-align: sub;
    }
  }
}

.integral-box {
  color: #fff;
  padding: 3px 10px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
}

.top-box {
  background: none;
  color: #fff;
  box-shadow: none;
  background: $myGgColor;
}

.top-right-box {
  flex: 1;
  margin: auto 10px;
  text-align: right;
  color: #fff;

  .right-img {
    width: 17px;
    vertical-align: sub;
  }
}
</style>